import { useState } from 'react';
import styles from './CopyButton.module.css';
import clsx from './clsx';

// =============================================================================
// CopyButton (throughline) — GAP 3. Ported from apps/web/src/pages/
// Presence.tsx's own inline CopyButton (that file's lines 104-125): SAME
// clipboard-write + 1.6s "Copied" flash idiom, restyled via this app's
// --tl-* CSS Modules instead of Tailwind utility classes (same VoiceTextarea.
// tsx / Orb.tsx separation this app's every component follows — see those
// files' own headers for why). A Clipboard API failure (no secure context,
// permission denied) is swallowed to the SAME idle state apps/web's version
// resolves to — the button just doesn't flash "Copied"; there is no
// meaningfully distinct 'error' UI a bare copy icon can show beyond that.
// =============================================================================

export function CopyButton({ text, label }: { text: string; label: string }) {
  const [done, setDone] = useState(false);
  return (
    <button
      type="button"
      onClick={() => {
        navigator.clipboard?.writeText(text).then(
          () => {
            setDone(true);
            window.setTimeout(() => setDone(false), 1600);
          },
          () => {},
        );
      }}
      className={clsx(styles.button, done && styles.buttonDone)}
      aria-label={`Copy ${label}`}
    >
      {done ? (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M5 13l4 4L19 7"
            stroke="currentColor"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"
            stroke="currentColor"
            strokeWidth="1.8"
          />
        </svg>
      )}
      {done ? 'Copied' : 'Copy'}
    </button>
  );
}
